<template>
  <div>
    <div class="subscribe">
      <input
        ref="input"
        type="email"
        v-model="emailInput"
        class="emailInput"
        placeholder="Your Email"
        required
      />
      <div>
        <button v-on:click="getEmail" id="subscribeButton">Subscribe</button>
      </div>
    </div>
    <div
      :style="{ visibility: subscribeMessageShow ? 'visible' : 'hidden' }"
      class="subscribeMessage"
    >
      {{ subscribeMessageText }}
    </div>
  </div>
</template>
<script>
var portalID = "8454268";
var formID = "64ee1b9a-c659-436e-b208-b260f5294923";
var endPoint =
  "https://api.hsforms.com/submissions/v3/integration/submit/" +
  portalID +
  "/" +
  formID;

export default {
  data: () => ({
    emailInput: "",
    subscribeMessageShow: false,
    subscribeMessageText: "message",
  }),

  methods: {
    getEmail() {
      const emailInputStatus = this.$refs.input.checkValidity();

      if (emailInputStatus) {
        this.sendEmailToHubspot(this.emailInput);
      } else {
        this.subscribeMessageText = "Please enter a valid email address.";
        this.subscribeMessageShow = true;
      }
    },

    sendEmailToHubspot(emailAddress) {
      const data = {
        fields: [
          {
            name: "email",
            value: emailAddress,
          },
        ],
      };

      fetch(endPoint, {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then(() => {
          // console.log('Success:');
          this.subscribeMessageText = "Success. Thank you for subscribing!";
          this.subscribeMessageShow = true;
        })
        .catch((error) => {
          console.error("Error:", error);
          this.subscribeMessageText = "Error: Please try again later";
          this.subscribeMessageShow = true;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}
.subscribe {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.emailInput {
  background: #fff;
  border: 2px solid #141a3c;
  outline: 0;
  padding: 9px 20px;
  border-radius: 50px;
  font-size: 14px;
  width: 200px;
  height: 20px;
  margin: 5px 0;
  margin-right: 5px;
}

#subscribeButton {
  background-color: rgb(20, 26, 60);
  border: 2px solid #141a3c;
  color: white;
  outline: 0;
  padding: 9px 20px;
  border-radius: 50px;
  width: 75px;
  height: 20px;
  font-size: 17px;
  margin: 5px 0;
  cursor: pointer;
}

#subscribeButton:hover {
  background-color: #555;
  border: 2px solid #555;
}

.subscribeMessage {
  text-align: center;
  margin: 20px 0;
}
</style>
>
